import { Box, CircularProgress, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'

class GestionUsuario extends Component {

    render(){
        return (
            <div className="listado" id="menu">
                <Container>
                    <h3>Gestión de Usuario</h3>
                    <TableContainer>
                        <Table sx={{minWidth: 500}} size="small" >
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell><a href="./GestionUsuarios-restablecerContrasenia">Restablecer Contraseña</a></TableCell>
                                    <TableCell><a href="./GestionUsuarios-usuarioAsiciado">Modificar Usuario Asociado</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./GestionUsuarios-usuariosEspeciales">Usuarios Especiales/Jefes</a></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Container>
            </div>
        )
    }
}

export default GestionUsuario